if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.numbers = [];
      this.intervalId = null;
      this.tick = this.handleTick.bind(this);
    }

    connectedCallback() {
      this.numbers = [...this.querySelectorAll('[data-number]')];
      this.startTimer();
    }

    disconnectedCallback() {
      if (this.intervalId) window.clearInterval(this.intervalId);
      this.intervalId = null;
    }

    parseTimeToParts(value) {
      const text = typeof value === 'string' ? value.trim() : '';
      const match = /^(\d{1,2}):(\d{2})$/.exec(text);
      if (!match) return null;
      const hours = Number.parseInt(match[1], 10);
      const minutes = Number.parseInt(match[2], 10);
      if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
      if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;
      return { hours, minutes };
    }

    getTodayAt(parts) {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate(), parts.hours, parts.minutes, 0, 0);
    }

    getWindowTimestamps() {
      const startParts = this.parseTimeToParts(this.getAttribute('data-time-start'));
      const endParts = this.parseTimeToParts(this.getAttribute('data-time-end'));
      if (!startParts || !endParts) return null;

      const start = this.getTodayAt(startParts).getTime();
      let end = this.getTodayAt(endParts).getTime();
      if (end <= start) end += 24 * 60 * 60 * 1000;

      return { start, end };
    }

    startTimer() {
      this.tick();
      if (this.intervalId) window.clearInterval(this.intervalId);
      this.intervalId = window.setInterval(this.tick, 1000);
    }

    handleTick() {
      const windowTs = this.getWindowTimestamps();
      if (!windowTs) {
        this.hidden = true;
        return;
      }

      const now = Date.now();
      const isActive = now >= windowTs.start && now < windowTs.end;
      this.hidden = !isActive;
      if (!isActive) return;

      const remaining = Math.max(0, Math.floor((windowTs.end - now) / 1000));
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;

      const pad2 = (n) => String(n).padStart(2, '0');
      const values = [hours, minutes, seconds].map(pad2);
      values.forEach((val, idx) => {
        const el = this.numbers[idx];
        if (el) el.textContent = val;
      });
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}